import { Institution } from "../models";
import { Request } from "../models/Request/Request";

export const mapInstitutionDetailsToRequest = (
  request: Request,
  institutionDetails: Institution
): Request => {
  const {
    id: institutionId,
    mandatoryForeignLanguages,
    electiveSubjects,
    languageSchoolingModels,
    foreignLanguages,
  } = institutionDetails;

  return {
    ...request,
    institutionId,
    mandatoryForeignLanguages,
    electiveSubjects,
    languageSchoolingModels,
    foreignLanguages,
    institutionProgram: null,
    institutionProgramId: null,
  };
};
